module.exports = __webpack_public_path__ + "static/img/47.f6d1ca0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/47.png
// module id = V4NR
// module chunks = 1